import Vue from 'vue'
import App from './App.vue'
import vueRouter from 'vue-router'
Vue.config.productionTip = false
import {route} from './router/index'
Vue.use(vueRouter)
const router = new vueRouter({
  routes: route
})
document.title = '西安市呼吸内科医疗质量控制中心'
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
